module.exports = __webpack_public_path__ + "static/one-4bd29b4cbb283b594015f01c6031c7bd.png";